import { render, staticRenderFns } from "./ThisTabs.vue?vue&type=template&id=1e2a8fc2&"
import script from "./ThisTabs.vue?vue&type=script&lang=js&"
export * from "./ThisTabs.vue?vue&type=script&lang=js&"
import style0 from "./ThisTabs.vue?vue&type=style&index=0&id=1e2a8fc2&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports